import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import {
  ApplicationContextProvider,
  ANNOUNCEMENT_DISMISS_COOKIE_KEY,
} from '@adc/ui-adc'
import analytics from '@adc/analytics'
import * as blueprint from '@adc/blueprint'
import configureStore from '../common/store'
import configureEventStore from '../common/event.store'
import Router from '../common/routes'
import App from '../common/containers/event.app.jsx'

const initialState = window.INITIAL_STATE.shellState || window.INITIAL_STATE

analytics.init(window.CONFIGS, analytics.createAnalyticsContext(initialState))

const readCookie = name => {
  const match = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
  return match ? decodeURIComponent(match.split('=')[1]) : undefined
}

const ssrHints = {
  announcementDismissedFingerprint: readCookie(ANNOUNCEMENT_DISMISS_COOKIE_KEY),
}

let store
let contents

if (window.location.pathname.startsWith('/event/details')) {
  store = configureEventStore(initialState)
  contents = <App ssrHints={ssrHints} />
} else {
  store = configureStore(initialState)
  contents = <Router ssrHints={ssrHints} />
}

hydrateRoot(
  window.ROOT_DOM_MOUNT,
  <ApplicationContextProvider
    graphWebsocket={new blueprint.primitives.GraphWebsocket()}
  >
    <Provider store={store}>{contents}</Provider>
  </ApplicationContextProvider>
)
